<template>
    <div class="flex items-center justify-between w-full border-b border-a-gray-e2e2e2" data-cy="container_financial_health_result_tabs">
        <button
            v-for="tab in tabs"
            :key="tab.id"
            :data-cy="`btn_financial_health_result_tab_${tab.id}`"
            class="flex-1 flex items-center justify-center gap-2 px-2 py-3 text-14 font-medium transition-all duration-200"
            :class="[
                activeTab === tab.id    
                    ? 'text-a-black' 
                    : 'text-a-black'
            ]"
            @click="selectTab(tab.id)"
        >
            <span 
                class="w-3 h-3 rounded-full flex-shrink-0"
                :style="{ backgroundColor: tab.color }"
            ></span>
            <span>{{ tab.label }}</span>
        </button>
    </div>
    <!-- Active indicator line -->
    <div class="relative h-0.5 -mt-0.5">
        <div 
            class="absolute h-0.5 bg-a-black transition-all duration-300"
            :style="activeIndicatorStyle"
        ></div>
    </div>
</template>

<script>
export default {
    name: "ResultTab",
    emits: ['change'],
    props: {
        // Array of tabs: [{ id, label, color }]
        tabs: {
            type: Array,
            required: true
        },
        // Currently active tab id
        activeTab: {
            type: String,
            required: true
        }
    },
    computed: {
        activeTabIndex() {
            return this.tabs.findIndex(t => t.id === this.activeTab);
        },
        activeIndicatorStyle() {
            const tabWidth = 100 / this.tabs.length;
            return {
                width: (tabWidth - 6) + '%',
                left: ((this.activeTabIndex * tabWidth) + 3) + '%',
                backgroundColor: '#000000'
            };
        }
    },
    methods: {
        selectTab(tabId) {
            this.$emit('change', tabId);
        }
    }
};
</script>
